import { baseResourceOptions } from './utils';
import emptyObserverCreator from '../shared/emptyObserverCreator';
import { TypeSpec } from 'src/models/Sidekick/SidekickModuleSpec';
import createDocumentResource from 'src/actions/shared/createDocumentResource';

const sidekickTypeSpecsResource = createDocumentResource<TypeSpec>({
  name: 'sidekickTypeSpecs',
  endpoint: 'v1/orgs/:orgId/sidekick-dashboard/customers/:customerId/flows-next/type-specs/:id',
  type: TypeSpec,
  observerCreator: emptyObserverCreator,
  options: baseResourceOptions,
});

export default sidekickTypeSpecsResource;
